module.exports = __webpack_public_path__ + "static/media/불암산.021104a9.jpg";